import { BREAK_POINT } from './constants';

export const isLargeDesktop = () => window.matchMedia(`(min-width: ${BREAK_POINT.BREAK_POINT_DESKTOP}px)`).matches;

export const isMobileOrTablet = () => window.matchMedia(`(max-width: ${BREAK_POINT.BREAK_POINT_TABLET - 1}px)`).matches;

export const isMobile = () => window.matchMedia(`(max-width: ${BREAK_POINT.BREAK_POINT_MOBILE - 1}px)`).matches;

export const isTablet = () => window.matchMedia(`(max-width: ${BREAK_POINT.BREAK_POINT_TABLET - 1}px)`).matches
    && window.matchMedia(`(min-width: ${BREAK_POINT.BREAK_POINT_MOBILE}px)`);

export const isDesktop = () => window.matchMedia(`(max-width: ${BREAK_POINT.BREAK_POINT_DESKTOP - 1}px)`).matches
    && window.matchMedia(`(min-width: ${BREAK_POINT.BREAK_POINT_TABLET}px)`).matches;

export const isLandscape = () => window.matchMedia('(orientation: landscape)').matches;
